import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import compileErrors from "../compileErorrs"
import { serviceCall, serviceCallPostParms, serviceCallSendDataArray } from "../serviceCall"
import { setLoading } from "../../feature/authSlice"

export const submitForApproval = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCallSendDataArray({
      url: apiConstants.Invoices.SUBMIT_FOR_APPROVAL,
      method: 'post',
      data: data,
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        toast.error(compileErrors(error.response.data.error))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
